import type { AgenticAttempt } from '../../api/search/searchApi';

// Status of the single app-wide agentic search. 'thinking' is transient UI
// state and is never allowed to survive a reload: the REHYDRATE handler in
// agenticSearchSlice normalizes a persisted 'thinking' back to 'idle'.
export type AgenticSearchStatus = 'idle' | 'thinking' | 'done' | 'error';

export interface AgenticSearchState {
  status: AgenticSearchStatus;
  // Envelope meta from the last completed search. Optional keys mirror the
  // wire contract's absence semantics: a trimming proxy deletes keys rather
  // than nulling them, and the state does the same.
  confident?: boolean;
  reasoning?: string;
  attempts?: AgenticAttempt[];
  // Present only when the service rewrote the query (last attempt differs
  // from the original); drives the "Searched as" caption.
  queryUsed?: string;
  // What the user actually typed; survives the success and failure
  // transitions of the search it started.
  originalQuery?: string;
  // Date.now() when results landed; the purge-on-mount TTL reads this.
  fetchedAt?: number;
  // SearchApiErrorKind of the last failure. Deliberately a plain string:
  // persisted blobs from older or newer builds must not be able to break a
  // narrower union.
  errorKind?: string;
}

const initialState: AgenticSearchState = {
  status: 'idle',
};

export { initialState };
